import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Container,
  makeStyles,
  Dialog,
  DialogTitle,
  List,
  ListItem,
  ListItemText
} from '@material-ui/core';

import Page from 'src/shared/ui/components/Page';
import Datatable from 'src/shared/ui/components/Datatable';

import getInventoryList from 'src/inventory/use-cases/getInventoryList';

import uploadFile from 'src/shared/use-cases/uploadFile';
import downloadFile from 'src/shared/use-cases/downloadFile';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  dialog: {
    textAlign: 'center'
  },
  dialogListItemSecondary: {
    textAlign: 'center',
    color: 'gray',
    backgroundColor: '#fff',
    padding: '6px 16px',
    marginLeft: '10%',
    width: '80%',
    borderRadius: 5
  },
  dialogListItemPrimary: {
    textAlign: 'center',
    color: '#fff',
    backgroundColor: '#4caf50',
    padding: '6px 16px',
    width: '80%',
    marginLeft: '10%',
    marginTop: '20px',
    borderRadius: 5
  }
}));

const InventoryListView = () => {
  const user = JSON.parse(localStorage.user);
  const companyHeadquarterId = localStorage.selectedUserHeadquarter;
  const classes = useStyles();

  const [list, setList] = useState({
    rows: [],
    count: 0
  });
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [orderBy, setOrderBy] = useState({
    columnName: null,
    orderBy: null
  });

  const [showImportExcelDialog, setShowImportExcelDialog] = useState(false);

  const navigate = useNavigate();

  const fetchList = async () => {
    const inventoryList = await getInventoryList({
      companyHeadquarterId,
      search,
      orderBy: orderBy.columnName
        ? `${orderBy.columnName} ${orderBy.orderBy}`
        : '',
      page,
      limit
    });

    setList(inventoryList);
  };

  useEffect(() => {
    fetchList();
  }, [page, limit, search, orderBy]);

  const handleSearch = (searchValue) => {
    setPage(0);
    setSearch(searchValue.target.value);
  };

  const handleChangePage = (pageIndex) => {
    setPage(pageIndex);
  };

  const handleChangeLimit = (limitIndex) => {
    setLimit(limitIndex);
  };

  const handleOrderBy = (column) => {
    setOrderBy(column);
  };

  const handleClickEdit = (event, id) => {
    navigate(`/app/inventory/${id}`, {
      replace: false
    });
  };

  const columnNameList = [
    'createdAt',
    'ProductType.name',
    'location',
    'identification=InventoryIdentification',
    'serial',
    'code',
    'barCode',
    'expirationDate'
  ];

  if (localStorage.selectedUserHeadquarter === 'all') {
    columnNameList.unshift('CompanyHeadquarter.name');
  }

  const handleClickImportExcelDialog = () => {
    setShowImportExcelDialog(true);
  };

  const handleCloseImportExcelDialog = () => {
    setShowImportExcelDialog(false);
  };

  const handleDownloadImportExcelTemplate = () => {
    downloadFile('/static/documents/templates/plantilla_inventario.xlsx');

    setShowImportExcelDialog(false);
  };

  const handleImportExcel = async () => {
    try {
      const excelFile = document.getElementById('file').files[0];
      if (excelFile.type.indexOf('sheet') === -1) {
        alert('El formato del archivo debe ser xlsx');
        return;
      }

      await uploadFile(
        `inventory/import/excel?companyHeadquarterId=${companyHeadquarterId}`,
        excelFile
      );

      setShowImportExcelDialog(false);

      alert('Excel importado');
    } catch (e) {
      alert('Excel no importado: se encontraron errores de formato');
    }
  };

  return (
    <Page className={classes.root} title="Inventario">
      <Dialog
        className={classes.dialog}
        onClose={handleCloseImportExcelDialog}
        aria-labelledby="inventory-importer-dialog"
        open={showImportExcelDialog}
      >
        <DialogTitle id="inventory-importer-dialog">
          Importar excel de inventario
        </DialogTitle>
        <List>
          <ListItem
            className={classes.dialogListItemSecondary}
            button
            onClick={handleDownloadImportExcelTemplate}
            key={'DOWNLOAD_TEMPLATE'}
          >
            <ListItemText primary={'Descargar plantilla'} />
          </ListItem>
          <br />
          <hr />
          <input type="file" id="file" name="file" />
          <br />
          <ListItem
            className={classes.dialogListItemPrimary}
            button
            onClick={handleImportExcel}
            key={'IMPORT_EXCEL'}
          >
            <ListItemText primary={'Subir excel'} />
          </ListItem>
        </List>
      </Dialog>
      <Container maxWidth={false}>
        <Datatable
          domainName="INVENTORY"
          dataList={list.rows}
          count={list.count}
          title="Inventario"
          addButtonText={
            user?.scopes.includes('create:inventory')
              ? 'Añadir inventario'
              : false
          }
          addButtonRoute={
            user?.scopes.includes('create:inventory')
              ? '/app/inventory/new'
              : Boolean(false)
          }
          importExcelButton={user?.scopes.includes('create:inventory')}
          exportExcelButton={Boolean(false)}
          handleClickImportExcel={handleClickImportExcelDialog}
          onSearch={handleSearch}
          onChangePageValue={handleChangePage}
          onChangePageLimit={handleChangeLimit}
          handleOrderBy={handleOrderBy}
          handleClickEdit={handleClickEdit}
          columnNameList={columnNameList}
        />
      </Container>
    </Page>
  );
};

export default InventoryListView;
